import React from 'react';
import BetaIcon, { IconColors, IconSizes } from '../../Icons/Icon';
import endpoints from '../../../define/endpoints';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import useGetVideoPreview from '../../../hooks/useGetVideoPreview';

//TODO: eventually remove preview prop
const CustomVideoPreview = ({ duration, preview, imageSrc, alt, cndString = '' }) => {

  const previewSrc = useGetVideoPreview(imageSrc);
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <>
      {preview ? preview : (
        <img
          src={`${previewSrc}${cndString}`}
          alt={alt || 'video preview'}
          loading='lazy'
        />
      )}
      <div className="reviews__media-frame__video-overlay">
        <div className="reviews__media-frame__video-play">
          <BetaIcon
            name={'videoThumbnail'}
            color={IconColors.ghost}
            size={IconSizes[24]}
          />
          <div className="reviews__media-frame__video-time">
            <Typography
              state={TypographyStates.white}
              variant={TypographyVariants.p4}
              weight={TypographyWeights['semi-bold']}
            >
              {duration ? formatTime(duration) : ''}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomVideoPreview;
